import { useState } from 'react';
// import SMSCode from '../../modules/user/wizard-pass/sms-code';
import CreateAccount from './CreateAccount';
import SMSCode from '../OTP/SMSCode';

const UserAccount = () => {
  const [step, setStep] = useState(1);
  const [dataFromChild, setDataFromChild] = useState('');

   // تابعی که به فرزند پاس داده می‌شود
   const handleChildData = (data) => {
    setDataFromChild(data);
  };

    // Go to next step
  const nextStep = () => {
    setStep(step + 1);
  };

  // Go back to prev step
  const prevStep = () => {
    setStep(step - 1);
  };

  // Restart Over
  const restartOver = () => {
    setStep(1);
  };

  switch (step) {
    case 1:
      return (
        <CreateAccount
          nextStep={nextStep}
          onSendData={handleChildData}
        />
      );
    case 2:
      return (
        <SMSCode
          nextStep={nextStep}
          prevStep={prevStep}
          values={dataFromChild}
        />
      );
    default:
      return <div>Invalid step</div>;
  }
};

export default UserAccount;